/**
 * Which kind of trace source a connection is, and what that changes on screen.
 * Langfuse hands over observations; qFlow hands over workflow runs.
 */

import { useConnectors } from "@/features/connectors/hooks";
import { useConnections } from "@/features/settings/hooks";
import { ApiError } from "@/lib/api";

export const QFLOW = "qflow";

/** A trace connection's type and its platform's label ("qFlow", "Langfuse"). */
export function useSourceKind(connectionId: string | null | undefined) {
  const connections = useConnections();
  const connectors = useConnectors();
  const connection = connections.data?.find((c) => c.id === connectionId);
  const type = connection?.connector_type;
  const label = connectors.data?.find((c) => c.type === type)?.label ?? "the trace source";
  return { connection, type, label, qflow: type === QFLOW };
}

/** The source refused its sign-in (qFlow refused the workbench, wrong Langfuse keys). */
export const isAuthError = (e: unknown) => e instanceof ApiError && e.code === "auth";
